import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom"
import Header from "../Header";
import { AddNewUser, FetchUserDetailsForAdmin } from "../../api/aws-api";
import { ConstructorEventPost, ConstructorEventGet } from "../../Event/event";
import { ClassicSpinner } from "react-spinners-kit";
import { notifySuccess, notifyError } from "../../Common/CommonFunction";

const CreateNewUser = () => {
  const [loading, setLoading] = useState(false);
  const [userName, setUserName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [parentname, setparentname] = useState("");
  const [address, setaddress] = useState("");
  const [usertype, setusertype] = useState("student");
  const [existingUsers, setExistingUsers] = useState([]);

  const navigate = useNavigate();

  // ================= FETCH EXISTING USERS =================
  useEffect(() => {
    const fetchExistingUsers = async () => {
      setLoading(true);
      try {
        const response = await ConstructorEventGet(FetchUserDetailsForAdmin);
        let users = [];
        if (response?.body) {
          let parsed = response.body;
          if (typeof parsed === "string") parsed = JSON.parse(parsed);
          if (typeof parsed === "string") parsed = JSON.parse(parsed);
          users = parsed;
        } else if (Array.isArray(response)) {
          users = response;
        }
        setExistingUsers(users);
      } catch (err) {
        notifyError("Failed to fetch existing users");
      } finally {
        setLoading(false);
      }
    };

    fetchExistingUsers();
  }, []);

  // ================= SUBMIT NEW USER =================
  const SubmitDataToCloud = async () => {
    if (!userName || !email || !address || !phone) {
      notifyError("Please Enter All Required Fields");
      return;
    }

    // Check if email or phone already exists
    const emailExists = existingUsers.some(
      (user) => user.email?.toLowerCase() === email.toLowerCase()
    );
    const phoneExists = existingUsers.some(
      (user) => user.mobile === phone
    );

    if (emailExists || phoneExists) {
      notifyError("Email or Phone Number already exists");
      return;
    }

    // Submit new user
    setLoading(true);
    const formdata = {
      Item: {
        user_name: userName,
        user_email: email.toLowerCase(),
        parent_name: parentname,
        user_address: address,
        user_mobile: phone,
        user_type: usertype,
        verified: true,
        googleId: "",
        user_status: "active",
        account: [{
          coursename: "foundation",
          totalfees: "4000",
          ammountpaid: "2000",
          remainingamount: "totalfees-amountpaid"
        }]
      }
    };

    try {
      const responsedata = await ConstructorEventPost(AddNewUser, formdata);
      if (responsedata[0] === "user_registered_verified") {
        notifySuccess("User Created Successfully");
        navigate("/codomo/admin/usermanagement");
      } else {
        notifyError("Failed to create user");
      }
    } catch (err) {
      notifyError("Failed to create user");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Header />
      {loading ? (
        <div className="spinner">
          <div className="spinner-wrapper">
            <ClassicSpinner size={50} color="black" loading={loading} />
          </div>
        </div>
      ) : (
        <div className="nav-tab-wrapper tabs section-padding">
          <div className="container">
            <div className="mini-title">Create New User</div>
            <div className="grid grid-cols-12 gap-[30px] bg-white shadow-box7 p-8 rounded-md mt-8">

              <div className="input-container xl:col-span-4 lg:col-span-4 sm:col-span-12 col-span-4">
                <input
                  type="text"
                  className="from-control"
                  value={userName}
                  onChange={(e) => setUserName(e.target.value)}
                  required
                />
                <span className={`input-placeholder ${userName && "active"}`}>Name *</span>
              </div>

              <div className="input-container xl:col-span-4 lg:col-span-4 sm:col-span-12 col-span-4">
                <input
                  type="email"
                  className="from-control"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
                <span className={`input-placeholder ${email && "active"}`}>Email *</span>
              </div>

              <div className="input-container xl:col-span-4 lg:col-span-4 sm:col-span-12 col-span-4">
                <input
                  type="text"
                  className="from-control"
                  value={phone}
                  onChange={(e) => setPhone(e.target.value)}
                  required
                />
                <span className={`input-placeholder ${phone && "active"}`}>Phone (without Country Code) *</span>
              </div>

              <div className="input-container xl:col-span-4 lg:col-span-4 sm:col-span-12 col-span-4">
                <input
                  type="text"
                  className="from-control"
                  value={parentname}
                  onChange={(e) => setparentname(e.target.value)}
                />
                <span className={`input-placeholder ${parentname && "active"}`}>Parent name</span>
              </div>

              <div className="input-container xl:col-span-4 lg:col-span-4 sm:col-span-12 col-span-4">
                <input
                  type="text"
                  className="from-control"
                  value={address}
                  onChange={(e) => setaddress(e.target.value)}
                  required
                />
                <span className={`input-placeholder ${address && "active"}`}>Address *</span>
              </div>

              <div className="xl:col-span-4 lg:col-span-4 sm:col-span-12 col-span-4">
                <select
                  className="from-control p-4 bg-[#ECECEC] text-[#827878]"
                  value={usertype}
                  onChange={(e) => setusertype(e.target.value)}
                  required
                >
                  <option value="student">Student</option>
                  <option value="mentor">Mentor</option>
                  <option value="admin">Admin</option>
                </select>
              </div>

              <div className="mt-8 xl:col-span-4 lg:col-span-4 sm:col-span-12 col-span-4">
                <button className="btn btn-black" onClick={() => navigate("/codomo/admin/usermanagement")}>CANCEL</button>
                <button className="btn ml-4 btn-primary" onClick={SubmitDataToCloud}>SAVE</button>
              </div>

            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default CreateNewUser;